import "./lib/jquery.mask";
import Pristine from "pristinejs";
import magnificPopup from "magnific-popup";

export default function modals() {
  // $('.form-popup').magnificPopup({
  //     type: 'inline',
  //     closeBtnInside: true,
  //     items: {
  //         src: '#callback-form'
  //     },
  //     preloader: false
  // });

class VForm {
    constructor(selector, callback = null) {
      this.el = typeof selector === 'object' ? selector : document.querySelector(selector)
      this.validator = null
      this.callback = callback
      this.popup = {
        open(title = 'Спасибо!', text = 'Наши специалисты скоро с Вами свяжутся!') {
          $.magnificPopup.open({
            items: {
              src: `<div class="white-popup">
                      <div class="h2 mb-4">${title}</div>
                      <p>${text}</p>
                    </div>`,
              type: 'inline'
            }
          });
        },
        close(delay = 0) {
          setTimeout(() => {
            $.magnificPopup.close();
          }, delay);
        }
      }

      this.init()
    }

    init() {
      const $self = this;

      this.validator = new Pristine(this.el);

      this.el.addEventListener('submit', (e) => {
        e.preventDefault();
        const valid = $self.validate();
        if(!valid) return;

        $self.submit();

      });
    }

    submit() {
      if(this.callback) {
        this.callback();
      }
    }

    validate() {
      const valid = this.validator.validate()
      return valid;
    }
}

const VTools = {
    VForm,
    author: '@khudyakv'
  }

window.VTools = VTools

  $(document).on('click', '.close-modal', function(e) {
      e.preventDefault();
      $.magnificPopup.close();
  });


  $('[data-modal]').magnificPopup();

  // const formList = document.querySelectorAll("[data-form-validate]");

  // for (let i = 0; i < formList.length; i++) {
  //   const form = formList[i];

  //   const pristine = new Pristine(form);

  //   form.addEventListener("submit", function (e) {
  //     e.preventDefault();
  //     const valid = pristine.validate();

  //     // if (!valid) return;
  //     if (form.dataset.formSuccess !== undefined && valid) {
  //       form.reset();
  //     }
  //   });
  // };

  $(".inputPhone").mask("+7 (000) 000-00-00", { clearIfNotMatch: true });
}
